import { darkColors, darkGrays, lightColors, lightGrays } from "@odm/theme";
import { getLocalTimezone } from "@odm/utils/dateTime";
import { getEnvironment } from "@odm/utils/utils";

// the version is provided during build
export const version = process.env.REACT_APP_VERSION_BUILD_NUMBER;

// By default we load the values from the local environment
// on the deployed app the values will be fetched from the server
let environment = {
  publicUrl: process.env.PUBLIC_URL,
  name: process.env.REACT_APP_ENVIRONMENT,
  appName: process.env.REACT_APP_NAME,
  graphQLServerUri: process.env.REACT_APP_GRAPHQL_SERVER_URI,
  subscriptionServerUri: process.env.REACT_APP_SUBSCRIPTION_SERVER_URI,
  fileServerUri: process.env.REACT_APP_FILE_SERVER_URI,
  apiServerUri: process.env.REACT_APP_API_SERVER_URI,
  omsUri: process.env.REACT_APP_OMS_URI,
  clientId: process.env.REACT_APP_AZURE_AD_APP_ID,
  tenantId: process.env.REACT_APP_AZURE_AD_TENANT_ID,
  authority: process.env.REACT_APP_AZURE_AD_AUTHORITY,
  redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI,
  appInsightsKey: process.env.REACT_APP_AZURE_APP_INSIGHTS_KEY,
};

export let languages = [
  {
    name: "English",
    tag: "en",
    default: true,
    rtl: false,
  },
  {
    name: "French",
    tag: "fr",
    default: false,
    rtl: false,
  },
  {
    name: "Arabic",
    tag: "ar",
    default: false,
    rtl: true,
  },
];
// if (isDev()) {
//   languages.push({
//     name: "Arabic",
//     tag: "ar",
//     default: false,
//     rtl: true,
//   });
// }

export const themes = [
  {
    name: "Light",
    tag: "light",
    img: "@odm/assets/img/settings/light.jpg",
    css: "",
    colors: lightColors,
    grays: lightGrays,
  },
  {
    name: "Dark",
    tag: "dark",
    img: "@odm/assets/img/settings/dark.jpg",
    css: "",
    colors: darkColors,
    grays: darkGrays,
  },
];
export const navbarBreakPoint = "xl"; // Vertical navbar breakpoint
export const topNavbarBreakpoint = "lg";
export const settings = {
  language: "en",
  theme: "light",
  timezone: getLocalTimezone(),
  isRTL: false,
  isDark: false,
  isTopNav: false,
  isVertical: true,
  get isCombo() {
    return this.isVertical && this.isTopNav;
  },
  showBurgerMenu: false, // controls showing vertical nav on mobile
  isNavbarVerticalCollapsed: false,
  navbarStyle: "transparent",
};
// export const maxFileUploadSize = 5240000; // 5MB
export const maxFileUploadSize = 20971520; // 20MB

function wrapPromise(promise) {
  let status = "pending";
  let result;
  let suspender = promise.then(
    (r) => {
      status = "success";
      result = r;
    },
    (e) => {
      status = "error";
      result = e;
    }
  );
  return {
    read() {
      if (status === "pending") {
        throw suspender;
      } else if (status === "error") {
        return environment;
      } else if (status === "success") {
        return result;
      }
    },
  };
}

export const fetchEnvironment = () => {
  let environmentPromise = getEnvironment();
  return wrapPromise(environmentPromise);
};

export const setEnvironment = (env) => {
  // copy values without replacing the object
  let name, value;
  for (name in env) {
    if (env.hasOwnProperty(name)) {
      value = env[name];
      environment[name] = value;
    }
  }
};

const allConfig = {
  version,
  languages,
  themes,
  settings,
  navbarBreakPoint,
  topNavbarBreakpoint,
  maxFileUploadSize,
  environment,
};
export default allConfig;
